import useApiMutation from 'shared/hooks/use-api-mutation';
import useInfiniteQueryHelpers from 'shared/hooks/use-infinite-query-helpers';
import {CategoryProps} from '../types';
import categoriesKeys from '../util/categories-keys';

export interface CreateCategoryProps extends Omit<CategoryProps, 'id'> {}

const useCreateCategory = () => {
  const {create} = useInfiniteQueryHelpers();

  const onSuccess = (data: CategoryProps) =>
    create(categoriesKeys.list(), data);

  return useApiMutation<CategoryProps>({
    url: '/categories',
    method: 'POST',
    errorTitle: 'Erro ao cadastrar categoria',
    successTitle: 'Cadastrar categoria',
    successMessage: 'Categoria cadastrada com sucesso',
    redirectUrl: '/menu/categories',
    onSuccess,
  });
};

export default useCreateCategory;
